import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <AboutSection />
        <CarouselSection />
        <UpdatesSection />
        <CommentsSection />
        <ContactSection />
        <FAQSection />
        <MediaSection />
        <IndexSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}